import React, { useEffect, useState } from "react";
import { Routes, Route, Link, useNavigate, Navigate } from "react-router-dom";
import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import { Authenticator, Loader, ThemeProvider, View, useAuthenticator } from "@aws-amplify/ui-react";
import theme from "./theme";

import Layout from "./components/Layout";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/profile";
import Users from "./pages/users";
import { configureApi, getCurrentUserInfo } from "./data/api";
import Badanti from "./pages/badanti";
import { UserRole } from "./data/interfaces";
import Task from "./pages/task";
import UserDetail from "./pages/users/UserDetail";
import BadantiBozze from "./pages/badanti/BadantiBozze";
import CreateBadanteBozzaForm from "./pages/badanti/CreateBadanteBozzaForm";
import ModifyBadanteBozzaForm from "./pages/badanti/ModifyBadanteBozzaForm";
import BadanteScheda from "./pages/badanti/BadanteScheda";
import ModifyBadanteForm from "./pages/badanti/ModifyBadanteForm";
import Clienti from "./pages/clienti";
import ClienteScheda from "./pages/clienti/ClienteScheda";
import ModifyClienteForm from "./pages/clienti/ModifyClienteForm";
import CreateClienteForm from "./pages/clienti/CreateClienteForm";

configureApi();

export default function App() {

  const { authStatus } = useAuthenticator(context => [context.authStatus]);
  const [role, setRole] = useState('');
  useEffect(() => {
    // retrieve user role to set visibility of menu
    const getUserInfo = async () => {
      setRole((await getCurrentUserInfo())['custom:role'] ?? UserRole.OPERATORE);
    };
    if(authStatus === 'authenticated' && role == ''){
      // retrieve role info on login (only if it hasn't been done already)
      getUserInfo();
    }
    if(authStatus !== 'authenticated'){
      // reset role on logout
      setRole('');
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Routes>
          <Route path="/" element={<Layout role={role}/>}>
              <Route index element={<Dashboard />} />
              <Route path="os" element={<Badanti />} />
              <Route path="os/detail" element={<BadanteScheda />} />
              <Route path="os/edit" element={<ModifyBadanteForm />} />
              <Route path="os/bozze" element={<BadantiBozze />} />
              <Route path="os/bozze/new" element={<CreateBadanteBozzaForm />} />
              <Route path="os/bozze/detail" element={<ModifyBadanteBozzaForm />} />
              <Route path="clienti" element={<Clienti />} />
              <Route path="clienti/detail" element={<ClienteScheda />} />
              <Route path="clienti/edit" element={<ModifyClienteForm/>} />
              <Route path="clienti/new" element={<CreateClienteForm />} />
              <Route path="profile" element={<Profile />} />
              <Route path="task" element={<Task />} />
              <Route path="users" element={(
                  role == UserRole.AMMINISTRATORE ? <Users /> :
                  role == '' ? <View minHeight="100vh"><Loader /></View> :
                  < Navigate  to="/"/>) } />
              <Route path="users/detail" element={(
                  role == UserRole.AMMINISTRATORE ? <UserDetail /> :
                  role == '' ? <View minHeight="100vh"><Loader /></View> :
                  < Navigate  to="/"/>) } />
            <Route path="*" element={< Navigate  to="/"/>} />
          </Route>
        </Routes>
      </div>
    </ThemeProvider>
  );
}